let API_BASE = "/api";
export class MarketingConstants {
  public static API_MARKETING_CREATE_POST = API_BASE + "/marketing/post";
}
